(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shampo-recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'shampo_recently_viewed_products_v1';
    const selector = '[data-shampo-recently-viewed-products]';

    function getConfig(root) {
      const source = root.querySelector('[data-shampo-recently-viewed-config]');
      if (!source) return null;

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        return null;
      }
    }

    function readItems() {
      try {
        const items = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return Array.isArray(items) ? items.filter((item) => item && item.handle) : [];
      } catch (error) {
        return [];
      }
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => {
        const entities = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        };
        return entities[character];
      });
    }

    function normalizeTag(value) {
      return String(value || '').trim().replace(/^[#＃]/, '');
    }

    function handleize(value) {
      return normalizeTag(value)
        .normalize('NFKC')
        .toLowerCase()
        .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
        .replace(/^-+|-+$/g, '');
    }

    function normalizeTags(value) {
      if (Array.isArray(value)) return value.map(normalizeTag).filter(Boolean);
      if (typeof value === 'string') return value.split(',').map(normalizeTag).filter(Boolean);
      return [];
    }

    function getBrandEntries(root) {
      return Array.from(root.querySelectorAll('[data-shampo-recently-viewed-brand-labels] [data-brand-label]'))
        .map((item) => {
          const label = item.getAttribute('data-brand-label') || '';
          const keys = (item.getAttribute('data-brand-keys') || '').split('||').map(normalizeTag).filter(Boolean);
          return { label, keys };
        })
        .filter((entry) => entry.label && entry.keys.length);
    }

    function resolveBrand(product, brandEntries) {
      const tags = normalizeTags(product.tags);
      if (!tags.length || !brandEntries.length) return '';

      const normalizedTags = tags.map((tag) => ({
        text: normalizeTag(tag).toLowerCase(),
        handle: handleize(tag)
      }));

      for (const entry of brandEntries) {
        for (const key of entry.keys) {
          const normalizedKey = normalizeTag(key).toLowerCase();
          const handleKey = handleize(key);
          const matched = normalizedTags.some((tag) => tag.text === normalizedKey || tag.handle === handleKey);
          if (matched) return entry.label;
        }
      }

      return '';
    }

    function productUrl(product) {
      if (product.url) return product.url;
      return `/products/${encodeURIComponent(product.handle)}`;
    }

    function formatMoney(cents, config, fallback) {
      const value = Number(cents);
      if (!Number.isFinite(value)) return fallback || '';

      try {
        return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'ja', {
          style: 'currency',
          currency: config.currency || 'JPY'
        }).format(value / 100);
      } catch (error) {
        return fallback || String(value / 100);
      }
    }

    function isDiscountEligible(product, config) {
      const targetTag = normalizeTag(config.discountTargetTag || '');
      const targetCollectionHandle = handleize(config.discountTargetCollectionHandle || '');

      if (targetCollectionHandle) {
        const collectionHandles = Array.isArray(product.collectionHandles)
          ? product.collectionHandles.map(handleize)
          : [];
        if (collectionHandles.includes(targetCollectionHandle)) return true;
      }

      if (!targetTag) return false;
      return normalizeTags(product.tags).some((tag) => normalizeTag(tag) === targetTag);
    }

    async function refreshProduct(product) {
      if (!product.handle) return product;

      try {
        const refreshUrl = product.url ? `${String(product.url).split('?')[0].replace(/\/$/, '')}.js` : `/products/${encodeURIComponent(product.handle)}.js`;
        const response = await fetch(refreshUrl, { credentials: 'same-origin' });
        if (!response.ok) return product;

        const data = await response.json();
        const variants = Array.isArray(data.variants) ? data.variants : [];
        const selectedVariant = variants.find((variant) => variant.available) || variants[0];

        return {
          ...product,
          id: data.id || product.id,
          title: data.title || product.title,
          url: product.url || `/products/${encodeURIComponent(product.handle)}`,
          vendor: product.vendor || data.vendor || data.type,
          type: data.type || product.type,
          image: data.featured_image || product.image,
          imageAlt: data.title || product.imageAlt || product.title,
          tags: normalizeTags(data.tags || product.tags),
          collectionHandles: product.collectionHandles || [],
          price: data.price || product.price,
          compareAtPrice: data.compare_at_price || 0,
          available: Boolean(data.available),
          variantId: selectedVariant ? selectedVariant.id : product.variantId,
          variantsCount: variants.length || product.variantsCount
        };
      } catch (error) {
        return product;
      }
    }

    function priceHtml(product, config) {
      const originalPrice = Number(product.price || 0);
      const discountEligible = isDiscountEligible(product, config);
      const discountPrice = Math.floor(originalPrice * 0.9);
      const strings = config.strings || {};
      const regularPrice = strings.regularPrice || '';
      const salePrice = strings.salePrice || '';

      return `
        <span class="shampo-discount-price${discountEligible ? ' is-discounted' : ''} shampo-album-product-card__price">
          <span class="visually-hidden visually-hidden--inline">${escapeHtml(regularPrice)}</span>
          ${
            discountEligible
              ? `<s class="shampo-discount-price__compare shampo-album-product-card__compare">${escapeHtml(formatMoney(originalPrice, config, product.priceFormatted))}</s>
                 <span class="visually-hidden visually-hidden--inline">${escapeHtml(salePrice)}</span>
                 <strong class="shampo-discount-price__current shampo-album-product-card__discount">${escapeHtml(formatMoney(discountPrice, config))}</strong>`
              : `<span class="shampo-discount-price__current shampo-album-product-card__discount">${escapeHtml(formatMoney(originalPrice, config, product.priceFormatted))}</span>`
          }
        </span>
      `;
    }

    function tagsHtml(product, config) {
      if (!config.showTags) return '';

      const tags = normalizeTags(product.tags).slice(0, 2);
      if (!tags.length) return '';

      return `
        <div class="shampo-album-product-card__tags">
          ${tags.map((tag) => `<span>${escapeHtml(tag)}</span>`).join('')}
        </div>
      `;
    }

    function cardHtml(product, config, brandEntries) {
      const url = productUrl(product);
      const title = product.title || '';
      const image = product.image || '';
      const imageAlt = product.imageAlt || title;
      const brand = config.showVendor ? resolveBrand(product, brandEntries) : '';
      const brandHtml = brand ? `<span class="shampo-album-product-card__vendor">${escapeHtml(brand)}</span>` : '';
      const media = image
        ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(imageAlt)}" width="800" height="800" loading="lazy" class="motion-reduce loaded">`
        : `<svg viewBox="0 0 1 1" role="img" aria-label="${escapeHtml(title)}"></svg>`;

      return `
        <article class="shampo-album-product-card">
          <a class="shampo-album-product-card__media" href="${escapeHtml(url)}" aria-label="${escapeHtml(title)}">
            ${media}
          </a>

          <div class="shampo-album-product-card__body">
            ${brandHtml}
            <a class="shampo-album-product-card__title" href="${escapeHtml(url)}">${escapeHtml(title)}</a>
            ${priceHtml(product, config)}
            ${tagsHtml(product, config)}
          </div>
        </article>
      `;
    }

    function setVisibility(root, items, config) {
      const empty = root.querySelector('[data-shampo-recently-viewed-empty]');
      const shouldHide = !items.length && config.hideWhenEmpty && !window.Shopify?.designMode;
      const section = root.closest('.shampo-recently-viewed');

      if (section) section.hidden = shouldHide;

      if (empty) {
        empty.hidden = Boolean(items.length) || config.hideWhenEmpty;
      }
    }

    async function render(root) {
      const config = getConfig(root);
      const list = root.querySelector('[data-shampo-recently-viewed-list]');
      if (!config || !list) return;

      root.closest('.shampo-recently-viewed')?.style.setProperty('--recently-viewed-desktop-columns', String(config.desktopColumns || 5));
      root.closest('.shampo-recently-viewed')?.style.setProperty('--recently-viewed-tablet-columns', String(config.tabletColumns || 4));

      let items = readItems()
        .sort((a, b) => Number(b.timestamp || 0) - Number(a.timestamp || 0))
        .filter((item) => {
          if (!config.hideCurrentProduct || !config.currentProductHandle) return true;
          return item.handle !== config.currentProductHandle;
        })
        .slice(0, Number(config.limit || 5));

      if (config.refreshProducts) {
        items = await Promise.all(items.map((item) => refreshProduct(item)));
      }

      const brandEntries = getBrandEntries(root);
      list.innerHTML = items.map((item) => cardHtml(item, config, brandEntries)).join('');
      setVisibility(root, items, config);
      root.querySelector('product-slider')?.setAttribute('data-total-items', String(items.length));
    }

    function init(container) {
      const roots = container.matches?.(selector) ? [container] : Array.from(container.querySelectorAll(selector));
      roots.forEach((root) => {
        render(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
